import "./Vod.scss"
import "video.js/dist/video-js.min.css"

import React, { useEffect } from "react"

import { FullMode, Header, VodFooter } from "@shared/components"
import {
  PaymentInformation,
  useLayerPopupContext,
  useSchedule,
} from "@shared/contexts"
import { getParam } from "@shared/modules"
import { isWindow7 } from "@shared/modules"

import { QuickMenu } from "live/components"
import { EventPopup } from "live/components/eventPopup"
import Product from "live/components/footer/Product"
import { useVodPlayer } from "vod/contexts"

import FlashVodPlayer from "./FlashVodPlayer"
import VideoPlayer from "./Player"
import ProductIframe from "./ProductIframe"
import Sidebar from "./Sidebar"

export default function () {
  const vodPlayer = useVodPlayer()

  const { schedule } = useSchedule()
  const { open } = useLayerPopupContext()

  const isFlash = getParam("player_type") === "flash" || isWindow7
  const isNotPaidSchedule =
    !!schedule?.paymentInformation &&
    PAYMENT_INFORMATION_WHITE_LIST.includes(schedule.paymentInformation)

  useEffect(() => {
    if (!isWindow7) return

    open("INSTALL_CHROME")
  }, [open])

  return (
    <>
      <section className="vodWrap">
        <Header right={<FullMode player={vodPlayer} />} />
        {isFlash ? <FlashVodPlayer /> : <VideoPlayer />}
        <VodFooter />
        <article className="sideB">
          <ProductIframe />
          <Sidebar />
        </article>

        <div className="product">
          <Product />
        </div>
        <QuickMenu />

        {isNotPaidSchedule && <EventPopup />}
      </section>
    </>
  )
}

const PAYMENT_INFORMATION_WHITE_LIST: PaymentInformation[] = ["ALL", "FREE"]
